"use strict";

(function () {
  if (window.firesmartFireDangerRatingBound) {
    return;
  }
  window.firesmartFireDangerRatingBound = true;
  document.addEventListener('click', function (event) {
    var panel = event.target.closest('.homepage__fire-danger-rating__colour, .fire-danger-rating-block__colour');
    if (!panel) {
      return;
    }

    // Keep in-panel links usable without closing the tab.
    if (event.target.closest('a')) {
      return;
    }
    panel.classList.toggle('active');
  }, false);
})();